import { type IMessageBodyMeet } from 'entities/Message'

export const parseMeet = (body: string): IMessageBodyMeet | string => {
  try {
    return JSON.parse(body)
  } catch (e) {
    /* empty */
  }

  return body
}
